import request from "@/config/request"; // 導入我們剛剛封裝好的 axios 實例


export function postWalletList(params) {
  return request({
    url: "/tools/postWalletList",
    method: "post",
    params, // GET 請求的查詢參數
  });
}
export function getWalletIncome(params) {
  return request({
    url: "/user/getWalletIncome",
    method: "get",
    params, // GET 請求的查詢參數
  });
}
export function getPerTotal(params) {
  return request({
    url: "/user/getPerTotal",
    method: "get",
    params, // GET 請求的查詢參數
  });
}

export function getNotification(params) {
  return request({
    url: "/text/getNotification",
    method: "get",
    params, // GET 請求的查詢參數
  });
}


export function getOtherNotice(params) {
  return request({
    url: "/text/list",
    method: "get",
    params, // GET 請求的查詢參數
  });
}

export function getHomeNotice(params) {
  return request({
    url: "/text/getHomeNotice",
    method: "get",
    params, // GET 請求的查詢參數
  });
}

// 獲取用戶列表的 GET 請求
export function getExchangeList(params) {
  return request({
    url: "/user/getExchangeList",
    method: "get",
    params, // GET 請求的查詢參數
  });
}
// 獲取用戶列表的 GET 請求
export function getMiningList(params) {
  return request({
    url: "/user/getMiningList",
    method: "get",
    params, // GET 請求的查詢參數
  });
}
// 獲取用戶列表的 GET 請求
export function getWithdrawalList(params) {
  return request({
    url: "/user/getWithdrawalList",
    method: "get",
    params, // GET 請求的查詢參數
  });
}

// 獲取用戶列表的 GET 請求
export function getUserInfoWallet(params) {
  return request({
    url: "/user/getUserInfoWallet",
    method: "get",
    params, // GET 請求的查詢參數
  });
}

// 新增用戶的 POST 請求
export function postWalletLogin(data) {
  return request({
    url: "/auth/postWalletLogin",
    method: "post",
    data, // POST 請求的 body 數據
  });
}

export function postWithdraw(data) {
  return request({
    url: "/user/postWithdraw",
    method: "post",
    data, // POST 請求的 body 數據
  });
}

export function postExchange(data) {
  return request({
    url: "/user/postExchange",
    method: "post",
    data, // POST 請求的 body 數據
  });
}

// 根據 ID 獲取單個用戶資訊
export function getUserById(id) {
  return request({
    url: `/users/${id}`,
    method: "get",
  });
}
